export default __webpack_public_path__ + "static/media/demoprofile1.d367bee5.svg";